import BidButton from './bidButton'

export default BidButton
